export default __webpack_public_path__ + "resources/icons/d330-705c.png";